import type { AppProfile, GlobalSettings, LoraSetting, ModelLists, NodeType, Segment, UpscaleSettings } from './types'

export const RECOMMENDED_UPSCALE_MODEL = 'RealESRGAN_x4plus_anime_6B.pth'
export const RECOMMENDED_UPSCALE_MODEL_URL =
  'https://github.com/xinntao/Real-ESRGAN/releases/download/v0.2.2.4/RealESRGAN_x4plus_anime_6B.pth'

export const DEFAULT_UPSCALE_SETTINGS: UpscaleSettings = {
  upscaleModel: RECOMMENDED_UPSCALE_MODEL,
  scale: 2,
  scaleMode: 'factor',
  longEdge: 1920,
  targetFps: 48,
  enhanceSource: 'wan',
  enhanceLoop: true,
  preserveAudio: true,
  concatFps: 24,
  concatCrf: 18,
}

export const DEFAULT_NEGATIVE =
  '口紅，色调艳丽，过曝，静态，细节模糊不清，字幕，风格，作品，静止，整体发灰，' +
  '最差质量，低质量，JPEG压缩残留，丑陋的，残缺的，多余的手指，多余的脚趾，' +
  '画得不好的手部，画得不好的脸部，畸形的，毁容的'

export const DEFAULT_SAMPLERS = [
  'uni_pc',
  'euler',
  'euler_ancestral',
  'dpmpp_2m',
  'dpmpp_2m_sde',
]

export const DEFAULT_SCHEDULERS = [
  'simple',
  'normal',
  'karras',
  'sgm_uniform',
  'beta',
]

export const emptyLoras = (count = 4): LoraSetting[] =>
  Array.from({ length: count }, () => ({ name: '', strength: 1 }))

export const createSegment = (nodeType: NodeType, prompt = ''): Segment => ({
  id: crypto.randomUUID(),
  prompt,
  frame_count: 81,
  node_type: nodeType,
  lora_high: emptyLoras(),
  lora_low: emptyLoras(),
  lora_mode: 'global',
})

export const defaultNodeTypeForPosition = (index: number, total: number): NodeType => {
  if (index === 0) return 'i2v'
  if (index === total - 1) return 'sviflf'
  return 'svi'
}

export const DEFAULT_GLOBAL: GlobalSettings = {
  unet_high: '',
  unet_low: '',
  clip: '',
  vae: '',
  clip_vision: '',
  accel_lora: 'None',
  accel_lora_strength: 1,
  svi_lora_high: 'None',
  svi_lora_low: 'None',
  svi_lora_strength: 1,
  cfg: 1,
  total_steps: 6,
  high_steps: 2,
  shift: 8,
  seed: -1,
  sampler: 'uni_pc',
  scheduler: 'simple',
  resolution: 960,
  overlap: 5,
  combine_fps: 16,
  color_match: true,
  color_match_mode: 'hm-mkl-hm',
  color_match_strength: 0.7,
  use_rife_bridge: false,
  rife_bridge_frames: 2,
  rife_model: 'rife49.pth',
  negative_prompt: DEFAULT_NEGATIVE,
  start_image: '',
  end_image: '',
  use_end_image: false,
  global_lora_high: emptyLoras(2),
  global_lora_low: emptyLoras(2),
}

export const createDefaultProfile = (): AppProfile => ({
  mode: 'multi',
  gs: structuredClone(DEFAULT_GLOBAL),
  segments: [createSegment('i2v'), createSegment('svi'), createSegment('sviflf')],
  simple_segment: createSegment('flf2v'),
})

export const EMPTY_MODEL_LISTS: ModelLists = {
  unet: [],
  clip: [],
  vae: [],
  clipVision: [],
  lora: ['None'],
  rife: [],
  samplers: DEFAULT_SAMPLERS,
  schedulers: DEFAULT_SCHEDULERS,
}
